export function first<T = any>(data: T[]) {
  return data && data?.length ? data[0] : null;
}
